import { createSlice } from "@reduxjs/toolkit";
import { BlogDefaultDataset } from "../data_model/blogModel/blog_model";

export const new_blog = createSlice({
  name: "new_blog",
  initialState: {
    value: {
      status: false,
      langMap: BlogDefaultDataset,
      defaultLangMap: BlogDefaultDataset,
    },
  },
  reducers: {
    //create first data item
    resetLangMap: (state, action) => {
      state.value.langMap = BlogDefaultDataset;
    },
    //add empty language dataset
    addNewLangData: (state, action) => {
      state.value.status = true;
      const incomingPayload = action.payload;
      const newArray = [...state.value.langMap.langMap, incomingPayload];
      state.value.langMap.langMap = newArray;
    },
    //update individual items in localization array
    replaceIndex: (state, action) => {
      state.value.status = true;
      const newPayload = action.payload;
      const existingPayload = state.value.langMap.langMap;
      const newUpdateData = existingPayload.map((item) =>
        item.langCode === newPayload.langCode ? newPayload : item
      );
      state.value.langMap.langMap = newUpdateData;
    },
  },
});

export const { resetLangMap, addNewLangData, replaceIndex } = new_blog.actions;

export default new_blog.reducer;
